import React from "react";

const Postage = ({ settings }) => {

  const returnAddress = settings?.physical?.return_address;

  const recipientAddress = "Recipient Name\n1234 Main St\nAnytown, USA 12345";

  return (
    <>
      <div className="gc__envelope" />
      <div className="gc__window" />
      <div className="gc__postage_wrapper">
        <div className="gc__postage_stamp">
          <p>PRESORTED</p>
          <p>FIRST-CLASS MAIL</p>
          <p>U.S. POSTAGE PAID</p>
          <p>MAILED FROM</p>
          <p>ZIP CODE 19611</p>
          <p>PERMIT NO. 1541</p>
        </div>
        <div className="gc__return_address">
          <img
            src={(returnAddress.logo) ? returnAddress.logo : undefined}
            alt=""
          />
          <p>{returnAddress.formatted}</p>
        </div>
        <div className="gc__shipping_address">
          <p>{recipientAddress}</p>
        </div>
      </div>
      <div className="gc__window_tint" />
    </>
  );
};

export default Postage;
